<app-student-module ModuleName="Student Assessments" [PrintOptions]="printOptions" [Loading]="loading">
  <sortable-table [data]="assessments" [data]="assessments" [headers]="headers"
                  defaultSort="school_year" [colorize]="colorize"></sortable-table>
</app-student-module>
